(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemstone-recommendations"] && !Shopify.designMode) return;
  try {
    
  var dialCode = '+91',
    phone,
    ajaxMessage = '.ajax-message',
    phoneNumber,
    otpNumber = '3456',
    sendOtp = true,
    submitBtn = $('.rudraksh').find('[type=submit]');
  var FORM_STORAGE_KEY = 'brahmagems_form_draft';

  function saveFormToStorage() {
    var $form = $('#ajax-form');
    if (!$form.length) return;
    var fullPhone = '';
    try {
      if ($('.phone-intl').length) fullPhone = $('.phone-intl').intlTelInput('getNumber') || '';
    } catch (e) {}
    if (!fullPhone) fullPhone = dialCode + ($('[name="phone"]').val() || '');
    var data = {
      name: $form.find('[name="name"]').val() || '',
      email: $form.find('[name="email"]').val() || '',
      phone: fullPhone || '',
      date_of_birth: $form.find('[name="date_of_birth"]').val() || '',
      time_of_birth: $form.find('[name="time_of_birth"]').val() || '',
      place_of_birth: $form.find('[name="place_of_birth"]').val() || '',
    };
    try {
      localStorage.setItem(FORM_STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function loadFormFromStorage() {
    var saved;
    try {
      saved = localStorage.getItem(FORM_STORAGE_KEY);
      if (!saved) return;
      saved = JSON.parse(saved);
    } catch (e) {
      return;
    }
    var $form = $('#ajax-form');
    if (!$form.length) return;
    if (saved.name) $form.find('[name="name"]').val(saved.name);
    if (saved.email) $form.find('[name="email"]').val(saved.email);
    if (saved.date_of_birth) $form.find('[name="date_of_birth"]').val(saved.date_of_birth);
    if (saved.time_of_birth) $form.find('[name="time_of_birth"]').val(saved.time_of_birth);
    if (saved.place_of_birth) $form.find('[name="place_of_birth"]').val(saved.place_of_birth);
    if (saved.phone && $('.phone-intl').length) {
      try {
        $('.phone-intl').intlTelInput('setNumber', saved.phone);
      } catch (e) {
        $form.find('[name="phone"]').val(saved.phone.replace(/^\+\d+/, ''));
      }
    }
  }

  $('.phone-intl')
    .intlTelInput({
      initialCountry: 'in',
      separateDialCode: true,
    })
    .on('countrychange', function (e, countryData) {
      dialCode = '+' + $(this).intlTelInput('getSelectedCountryData').dialCode;
    });

  $(function () {
    loadFormFromStorage();
  });

  $('body').on('input change', '#ajax-form input', function () {
    saveFormToStorage();
  });

  document.addEventListener('DOMContentLoaded', function () {
    const inputs = document.querySelectorAll('#otp > input');
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('input', function () {
        if (this.value.length > 1) {
          this.value = this.value[0]; //
        }
        if (this.value !== '' && i < inputs.length - 1) {
          inputs[i + 1].focus(); //
        }
        getOTPNumber();
      });

      inputs[i].addEventListener('keydown', function (event) {
        if (event.key === 'Backspace') {
          this.value = '';
          if (i > 0) {
            inputs[i - 1].focus();
          }
        }
        getOTPNumber();
      });
    }

    function getOTPNumber() {
      otpNumber = '';
      inputs.forEach((input) => {
        otpNumber += input.value;
      });
    }
  });

  $('[name="phone"]').on('keyup', function () {
    let value = $(this).val(
      $(this)
        .val()
        .replace(/^0*(.+)/, '$1')
    );
    if (phoneNumber == $(this).val() && phoneNumber != '') {
      sendOtp = true;
      submitBtn.val('Verify OTP & Get Recommendation');
    } else {
      submitBtn.val('Submit');
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    const dobInput = document.querySelector('[name="date_of_birth"]');
    const today = new Date().toISOString().split('T')[0];
    dobInput.max = today;
  });

  $('#ajax-form').validate({
    rules: {
      phone: {
        required: true,
      },
      name: {
        required: true,
      },
      email: {
        required: true,
        email: true,
      },
      gender: {
        required: true,
      },
      purpose: {
        required: true,
      },
      body_weight: {
        required: true,
      },
      budget: {
        required: true,
      },
      time_of_birth: {
        required: true,
      },
      date_of_birth: {
        required: true,
      },
      place_of_birth: {
        required: true,
      },
    },
    messages: {
      name: 'Please enter name',
      phone: 'Please enter phone number',
      time_of_birth: 'Please enter time of birth ',
      date_of_birth: 'Please enter date of birth ',
      place_of_birth: 'Please enter place of birth ',
      gender: 'Please enter gender. ',
      purpose: 'Please select purpose. ',
      body_weight: 'Please enter body weight. ',
      budget: 'Please select budget. ',
      email: {
        required: 'Please registered email id',
        email: 'Please enter valid email id',
      },
    },
    errorPlacement: function (error, element) {
      var placement = $(element).data('error');
      if (placement) {
        $(placement).html(error);
      } else {
        error.insertAfter(element);
      }
    },
    submitHandler: function (form) {
      $(this).find('[type=submit]').attr('disabled', '');
      let formdata = new FormData(form);
      formdata.append('phone_code', dialCode);
      formdata.append('otp', otpNumber);
      formdata.append('current_url', window.location.href);
      let phone = $('[name="phone"]').val();

      if (dialCode == '+91') {
        if (phone.length != 10) {
          $('.ajax-message').html('<div class="alert alert-danger">Please enter 10 digits phone number.</div>');
          return false;
        }
      } else {
        if (phone.length > 15) {
          $('.ajax-message').html('Please enter valid phone number.');
          return false;
        } else if (phone.length < 2) {
          $('.ajax-message').html('Please enter valid phone number.');
          return false;
        }
      }

      // if (phoneNumber != phone) {
      //     sendOtp = false;
      // }

      phoneNumber = phone;

      $.ajax({
        url: 'https://api.brahmagems.com/shopify/brahmagems/' + (sendOtp ? 'verify' : 'send') + '-otp',
        type: 'POST',
        data: formdata,
        contentType: false,
        processData: false,
        beforeSend: function () {
          $(ajaxMessage).html(
            '<div class="alert alert-success"><i class="fa fa-refresh fa-spin"></i> Please wait... </div>'
          );
        },
        success: function (res) {
          var apiGems = res.data && res.data.gems ? res.data.gems : [];
          var userName = res.data && res.data.name ? res.data.name : '';
          const gemLabels = [
            'HEALTHY STONE',
            'BENEFITS STONE',
            'LUCKY STONE', // For all remaining gems beyond index 2
          ];
          fetch(window.recommendationUrl)
            .then(function (resp) {
              return resp.json();
            })
            .then(function (themeGems) {
              var byHandle = {};
              (themeGems || []).forEach(function (g) {
                if (g && g.handle) byHandle[g.handle] = g;
              });
              var indexNumber = 0;
              var merged = apiGems
                .map(function (apiGem) {
                  var handle = apiGem.handle || (apiGem.gem_key || '').replace(/_/g, '-');
                  var theme = byHandle[handle];
                  if (!theme) return null;
                  return {
                    name: `${gemLabels[indexNumber++]}: ${theme.name}`,
                    image: theme.image,
                    url: theme.url,
                    wear_day: apiGem.wear_day,
                  };
                })
                .filter(Boolean);
              localStorage.setItem('gems', JSON.stringify(merged));
              localStorage.setItem('name', userName);
              showRecommendation();
            })
            .catch(function () {
              localStorage.setItem('gems', JSON.stringify(apiGems));
              localStorage.setItem('name', userName);
              showRecommendation();
            });
          // $(ajaxMessage).html('<div class="alert alert-success">' + res.message + '</div>');
          // $(".otp-box").show();
          // submitBtn.val('Verify OTP & Get Recommendation');
          // if(sendOtp){
          //   submitBtn[0].reset();
          // }
          // submitBtn[0].reset();
          // sendOtp = true;
        },
        complete: function () {
          submitBtn.removeAttr('disabled');
          setTimeout(function () {
            $(ajaxMessage).html('');
          }, 20000);
        },
        error: function (error) {
          let data = JSON.parse(error.responseText);
          if (error.status === 422) {
            var errorString = '<ul class="ps-3 m-0">';
            $.each(data.errors, function (key, value) {
              errorString += '<li>' + value + '</li>';
            });
            errorString += '</ul>';
            response = errorString;
          } else {
            response = data.error;
          }

          $(ajaxMessage).html('<div class="alert alert-danger">' + response + '</div>');
        },
      });
      return false;
    },
  });

  var DEFAULT_HEADING_HTML = 'Know your <b>Gemstone</b>';

  $('body').on('click', '.edit-form', function (e) {
    e.preventDefault();
    $('#recommendations-view').hide();
    $('#form-view').show();
    var heading = document.getElementById('dynamic-heading');
    if (heading) heading.innerHTML = DEFAULT_HEADING_HTML;
  });

  function showRecommendation() {
    let gems = localStorage.getItem('gems');
    let name = localStorage.getItem('name');

    if (!gems || !name) return;

    // ✅ HEADING REPLACE HERE
    const heading = document.getElementById('dynamic-heading');
    if (heading) {
      heading.innerHTML = `
          Hello <strong>${name}</strong> !<br>
          <span style="font-size:14px; font-family:Montserrat,sans-serif;">
            Here are your recommended gemstones
            <a href="#" class="edit-form ms-2">Edit details</a>
          </span>
        `;
    }

    $('#form-view').hide();
    gems = JSON.parse(gems);

    // function showRecommendation() {
    //     let gems = localStorage.getItem('gems');
    //     let name = localStorage.getItem('name');

    //     if (!gems) return;

    //     $("#ajax-form").hide();

    //     gems = JSON.parse(gems);

    let recommendation = ``;

    //         recommendation += `
    //   <p class="text-center">
    //     Hello <strong>${name}</strong> ! <br>
    //     Here are your recommended gemstones.
    //     <a href="#" class="edit-form fs-sm ms-2">Edit details</a>
    //   </p>
    // `;

    // recommendation += `<p class="text-center">Hello <b>${name}</b>, here are your recommended gems. &nbsp;&nbsp;&nbsp;&nbsp;<a href="" class="edit-form fs-sm">Edit details</a></p> `;
    recommendation += `<div class="row g-4 d-none d-md-flex">`;

    Object.values(gems).forEach((gem) => {
      // FIXED HERE
      recommendation += `
                <div class="col-6 col-md-4 text-center">
                    <a href="${gem.url}" class="category-item">
                        <div class="category-image">
                            <img src="${gem.image}" alt="${gem.name}" loading="lazy">
                        </div>
                        <p class="category-title">${gem.name}</p>
                        <p class="wear-text">Wear: ${gem.wear_day}</p>
                    </a>
                </div>
            `;
    });

    recommendation += `</div>`;

    $('#recommendations-view').html(recommendation).show();
  }

  showRecommendation();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CARD_SECTION = 'product-card';
  var runId = 0; // theme editor me section reload hone par purane run ko rokne ke liye

  function $grid()  { return document.getElementById('product-grid'); }
  function $empty() { return document.getElementById('wishlist-empty'); }
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }

  function updateCount(n) {
    document.querySelectorAll('.wishlist-count').forEach(function (b) {
      b.textContent = n;
      b.style.display = n ? '' : 'none';
    });
  }

  function showEmpty() {
    var g = $grid(), e = $empty();
    if (g) g.innerHTML = '';
    if (e) e.hidden = false;
  }

  function getHandles() {
    try { return (typeof Wishlist !== 'undefined' && Wishlist.get()) || []; }
    catch (err) { return []; }
  }

  /* ---------- actions ---------- */
  function removeItem(handle, li) {
    if (typeof Wishlist === 'undefined') return;
    var items = Wishlist.get().filter(function (h) { return h !== handle; });
    Wishlist.save(items);
    updateCount(items.length);

    li.style.opacity = '0';
    setTimeout(function () {
      li.remove();
      if (!items.length) showEmpty();
    }, 300);
  }

  function makeAddToCart(handle) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wishlist-add-to-cart-btn';
    btn.innerHTML = '<span>Add to Cart</span>';

    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;
      var label = btn.firstElementChild;
      btn.disabled = true;
      label.textContent = 'Adding...';

      try {
        var product = await (await fetch('/products/' + encodeURIComponent(handle) + '.js')).json();

        // multiple options wale product me variant user ko choose karna hoga
        if (product.variants.length > 1) {
          window.location.href = product.url || ('/products/' + handle);
          return;
        }

        var variant = product.variants.find(function (v) { return v.available; });
        if (!variant) { label.textContent = 'Sold out'; return; }

        var r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        });
        if (!r.ok) throw new Error('Add to cart failed');

        label.textContent = 'Added!';
        window.location.href = cartUrl();
      } catch (err) {
        console.error(err);
        label.textContent = 'Error, try again';
        btn.disabled = false;
        setTimeout(function () { label.textContent = 'Add to Cart'; }, 2000);
      }
    });
    return btn;
  }

  function makeRemove(handle, li) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wishlist-remove-btn';
    btn.innerHTML = '<span>Remove</span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      removeItem(handle, li);
    });
    return btn;
  }

  function decorate(li, handle) {
    li.dataset.handle = handle;

    // image ke upar wala heart bhi remove kare
    var heart = li.querySelector('[data-wl-remove]');
    if (heart) {
      heart.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        removeItem(handle, li);
      });
    }

    li.appendChild(makeAddToCart(handle));
    li.appendChild(makeRemove(handle, li));
    return li;
  }

  /* ---------- card fetch ---------- */
  async function fromSection(handle) {
    var res = await fetch('/products/' + encodeURIComponent(handle) + '?section_id=' + CARD_SECTION);
    if (!res.ok) throw new Error('Section failed');
    var tmp = document.createElement('div');
    tmp.innerHTML = await res.text();
    var li = tmp.querySelector('li.wl-card');
    if (!li) throw new Error('No card in section');
    return li;
  }

  // fallback: section na mile to same look ka card JSON se banao
  async function fromJson(handle) {
    var res = await fetch('/products/' + encodeURIComponent(handle) + '.js');
    if (!res.ok) throw new Error('Product not found');
    var p = await res.json();

    var li = document.createElement('li');
    li.className = 'grid__item wl-card';

    var media = document.createElement('div');
    media.className = 'wl-card__media';
    var a = document.createElement('a');
    a.href = p.url; a.className = 'wl-card__img';
    if (p.featured_image) {
      var img = document.createElement('img');
      img.src = p.featured_image; img.alt = p.title; img.loading = 'lazy';
      a.appendChild(img);
    }
    media.appendChild(a);
    media.insertAdjacentHTML('beforeend',
      '<div class="wl-card__icons"><button type="button" class="wl-card__heart" data-wl-remove aria-label="Remove from wishlist">' +
      '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></button></div>');

    var info = document.createElement('div');
    info.className = 'wl-card__info';
    var t = document.createElement('a');
    t.href = p.url; t.className = 'wl-card__title'; t.textContent = p.title;
    var m = document.createElement('p');
    m.className = 'wl-card__meta';
    var sku = p.variants && p.variants[0] && p.variants[0].sku;
    m.textContent = sku ? 'SKU: ' + sku : '';
    var pr = document.createElement('p');
    pr.className = 'wl-card__price';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    try { pr.textContent = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: cur }); }
    catch (e) { pr.textContent = (p.price / 100).toFixed(2); }
    info.appendChild(t); info.appendChild(m); info.appendChild(pr);

    li.appendChild(media);
    li.appendChild(info);
    return li;
  }

  async function buildCard(handle) {
    try { return decorate(await fromSection(handle), handle); }
    catch (e) {
      console.warn('Section failed, using fallback:', handle);
      try { return decorate(await fromJson(handle), handle); }
      catch (err) { console.error('Product fallback failed:', handle, err); return null; }
    }
  }

  /* ---------- main ---------- */
  async function loadWishlist() {
    var my = ++runId;
    var g = $grid(), e = $empty();
    if (!g) return;

    var handles = getHandles();
    updateCount(handles.length);

    if (!handles.length) { showEmpty(); return; }

    e.hidden = true;
    g.innerHTML = '';

    // sab products ek saath fetch, order same rehta hai
    var cards = await Promise.all(handles.map(buildCard));
    if (my !== runId) return; // naya run start ho chuka hai

    var shown = 0;
    cards.forEach(function (li) { if (li) { g.appendChild(li); shown++; } });
    if (!shown) showEmpty();
  }

  document.addEventListener('DOMContentLoaded', loadWishlist);
  document.addEventListener('shopify:section:load', loadWishlist);                          // theme editor
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) loadWishlist(); }); // back button
})();

  } catch(e) { console.error(e); }
})();
})();
